import React, { MutableRefObject, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { RequiredFieldsInformation } from "go-security/components/RequiredFieldsInformation/RequiredFieldsInformation";
import { UpsellApi, UpsellVisibilityType } from "../../../../../../../../../../services/Api/Organization/types";
import UpsellForm from "./components/UpsellForm";

interface HistoryStateProps {
	upsell?: UpsellApi;
}

const OrganizationMenuUpsellsNewPage = (): JSX.Element => {
	const { t } = useTranslation();
	const { state } = useLocation<HistoryStateProps>();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const upsell: MutableRefObject<UpsellApi> = useRef(
		state?.upsell || {
			status: "ENABLED",
			visibility_type: UpsellVisibilityType.ALL,
			name: "",
			id: null,
			priority: null,
			conditions: [],
			entities: [],
		}
	);

	useEffect(() => {
		handleChangeTabTitle(t("modules.upsell.header.new.title"));
	}, []);

	const renderSubtitle = () => <RequiredFieldsInformation />;

	return (
		<>
			<Header title={t("modules.upsell.header.new.title")} subtitle={renderSubtitle()} />
			<UpsellForm upsell={upsell.current} />
		</>
	);
};

export default OrganizationMenuUpsellsNewPage;
